module.exports = __webpack_public_path__ + "images/admin/sales-leader-header.png";